module.exports = __webpack_public_path__ + "static/img/job.7ea80de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/job.jpg
// module id = XUoI
// module chunks = 0